import { useLocation, useNavigate } from "react-router-dom";
import { isInitialLocationKey } from "web_myplann/Shared/Utils/backNavigation";

export const useGoBack = (fallbackPath: string) => {
	const navigate = useNavigate();
	const { key } = useLocation();

	const isFirstEntry = isInitialLocationKey(key);

	return () => {
		if (isFirstEntry) {
			navigate(fallbackPath);
			return;
		}
		navigate(-1);
	};
};
